"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../../assets/css/components/switch.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Switch = function Switch(_ref) {
  var isOn = _ref.isOn,
      handleToggle = _ref.handleToggle,
      onColor = _ref.onColor,
      id = _ref.id;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
    checked: isOn,
    onChange: handleToggle,
    className: "react-switch-checkbox",
    id: id,
    type: "checkbox"
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: "react-switch-label",
    style: {
      background: isOn && onColor
    },
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "react-switch-button"
  })));
};

Switch.propTypes = {
  isOn: _propTypes["default"].bool.isRequired,
  onColor: _propTypes["default"].string,
  handleToggle: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string
};
Switch.defaultProps = {
  isOn: false,
  onColor: "#18AF8B",
  handleToggle: function handleToggle() {},
  id: "react-switch-new"
};
var _default = Switch;
exports["default"] = _default;